<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span>For Professors Elmer Blistein and George<br/>Monteiro, and the English Department of<br/>Brown University. Thanks for taking a chance.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?21eb06e5